<div class="d-flex align-items-center justify-content-evenly gap-3 py-4">
  <a
    href="https://www.facebook.com/profile.php?id=100088023722684"
    target="_blank"
    class="d-flex"
  >
    <img
      alt="Facebook icon"
      class="cursor-pointer"
      height="36"
      src="assets/pics/facebook.png"
    />
  </a>

  <a
    href="https://www.linkedin.com/company/easylot/"
    target="_blank"
    class="d-flex"
  >
    <img
      alt="Linkedin icon"
      class="cursor-pointer"
      height="36"
      src="assets/pics/linkedin.png"
    />
  </a>

  <!-- <a [routerLink]="[]" class="d-flex">
      <img
        alt="Instagram icon"
        class="cursor-pointer"
        height="36"
        src="assets/pics/instagram.png"
        width="36"
      />
    </a> -->

  <!-- <a [routerLink]="['']" class="d-flex">
      <img
        alt="YouTube icon"
        class="cursor-pointer"
        height="36"
        src="assets/pics/youtube.png"
        width="48"
      />
    </a> -->
</div>
